import { CHAIN_IDS } from "enums/chainIds";

import { CHAINS } from "config/networks";

import { isChainIdSupported } from "utils/blockchain";

class WebExplorerLinksFactory {
  static address(chainId: CHAIN_IDS, value: string): string {
    return `${this.getExplorerUrl(chainId)}/address/${value}`;
  }

  static tx(chainId: CHAIN_IDS, value: string): string {
    return `${this.getExplorerUrl(chainId)}/tx/${value}`;
  }

  private static getExplorerUrl(chainId: CHAIN_IDS) {
    if (!isChainIdSupported(chainId)) {
      return "";
    }
    const chain = CHAINS.find((chain) => chain.chainId === chainId);

    return chain?.explorers?.[0].url ?? "";
  }
}

export default WebExplorerLinksFactory;
